module.exports = __webpack_public_path__ + "img/firefox2.25135521.png";